import OTP from "antd/es/input/OTP"

export const AUTH_TOKEN_COOKIE_KEY = "authToken"

export const API_URLS = {
  OTP_LOGIN: "/otpLogin",
  PROJECTS: "/projects",
  VERIFY_OTP: "/verifyLoginOtp",
  AUTHORIZE_USER: "/authorize",
}
